import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {PresentationItem} from "../types/presentation";
import {v4 as uuidv4} from "uuid";

const PRESENTATION_COLLECTION_ID = "682b314700396e5b8429"

const databases = new Databases(client);

export const presentationService = {

  async list(queries: string[] = [], limit: number = 25): Promise<PresentationItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        PRESENTATION_COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const presentationItems = response.documents.map(doc => doc as unknown as PresentationItem);
      return presentationItems;
    } catch (error) {
      console.error('Error listing presentation items:', error);
      throw error;
    }
  },


  async createPresentationItem(data: PresentationItem): Promise<PresentationItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        PRESENTATION_COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as PresentationItem;

      return createdItem;
    } catch (error) {
      console.error('Помилка створення:', error); // change
      throw error;
    }
  },

  async update(data: PresentationItem): Promise<PresentationItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedPresentation = await databases.updateDocument(
        database_id,
        PRESENTATION_COLLECTION_ID,
        id,
        correctData
      ) as unknown as PresentationItem;
      return updatedPresentation;
    } catch (error) {
      console.log(error)
      console.error('Помилка оновлення запису!', error);
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        PRESENTATION_COLLECTION_ID,
        id
      );
    } catch (error) {
      // console.error('Error deleting news:', error);
      throw error;
    }
  },
}